<template>
  <v-container>
    <h1 class="text-center">STOCK IN SHOP</h1>
    <v-row class="text-center">
      <v-col></v-col>
      <v-col>
        <v-btn icon @click="getShopData">
          <v-icon>mdi-sync</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-text-field
      v-model="search"
      append-icon="mdi-magnify"
      label="Search"
      single-line
      hide-details
    ></v-text-field>
    <br />
    <v-data-table
      :headers="headers"
      :items="SHOPDATA"
      :search="search"
      :items-per-page="10"
      class="elevation-1"
    >
      <template v-slot:item.stock="{ item }">
        <p>{{item.stock +'/'+item.store_stock}}</p>
      </template>
      <template v-slot:item.id="{ item }">
        <template v-if="item.store_stock >=1">
          <v-icon color="green" dark class="mr-2" @click="updateStore(item)">mdi-update</v-icon>
        </template>
        <template v-else>
          <v-icon color="gray">mdi-update</v-icon>
        </template>
      </template>
    </v-data-table>
    <v-dialog v-model="getStockDialog" persistent scrollable max-width="50%">
      <v-card>
        <v-form ref="form">
          <v-card-title>
            <span class="headline">GET STOCK FROM STORE ROOM</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <p class="text-center">STOCK AVILABLE {{getItems.store_stock}}</p>
              <v-text-field
                label="HOW MUCH NEEDED *"
                required
                v-model="stickneeded"
                :rules="[RULES.required, RULES.mrp, (value)=>{ return value<=getItems.store_stock || 'Insufficient Stock in Store room';}]"
              ></v-text-field>
            </v-container>
          </v-card-text>
        </v-form>
        <v-card-actions>
          <v-row>
            <v-col>
              <v-btn color="error" block @click="getStockDialog = false">Close</v-btn>
            </v-col>
            <v-col>
              <v-btn color="primary1" block dark @click="getStock">ADD</v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      search: "",
      getStockDialog: false,
      stickneeded: 1,
      headers: [
        {
          text: "Product Name",
          align: "start",
          sortable: true,
          value: "name"
        },
        { text: "MRP ₹", value: "mrp" },
        { text: "Category", value: "category" },
        { text: "SHOP/STORE", sortable: true, value: "stock" },
        { text: "Actions", value: "id", width: "10%" }
      ],
      getItems: {
        p_id: "",
        store_stock: ""
      }
    };
  },
  computed: {
    ...mapGetters(["SHOPDATA", "RULES"])
  },
  created() {},
  methods: {
    ...mapActions(["GET_SHOP", "UPDATE_SHOP"]),
    getShopData() {
      this.$store.commit("SET_LOADING", true);
      this.GET_SHOP().then(() => {
        this.$store.commit("SET_LOADING", false);
      });
    },
    updateStore(item) {
      this.getItems = {
        p_id: item.p_id,
        store_stock: item.store_stock
      };
      this.getStockDialog = true;
    },
    getStock() {
      if (this.$refs.form.validate()) {
        this.$store.commit("SET_LOADING", true);
        this.UPDATE_SHOP({
          p_id: this.getItems.p_id,
          store_stock: this.getItems.store_stock,
          needed: this.stickneeded
        }).then(() => {
          this.getItems = {
            p_id: "",
            store_stock: ""
          };
          this.getStockDialog = false;
          this.$store.commit("SET_LOADING", false);
        });
      }
    }
  }
};
</script>

<style>
</style>